module.exports = __webpack_public_path__ + "img/aitutor_img_13.588337cb.png";